import Vue from "vue";
import Vuex from "vuex";
import store from "../index.js";
import {
	getAccessData,
	getAccessRoles,
	getUserData,
	userLogin,
	userLogOut,
} from "../../utils/apiFunctions.js";
import { resetRouter } from "../../router";
import { setToken, clearCookies, getRefreshToken, getToken } from "../../utils/tokenCheck";
const qs = require("qs");
Vue.use(Vuex);
const state = () => ({
	showMenu: false,
	licenseKey: "",
	token: "",
	refreshToken: "",
	user: {
		userID: "",
		email: "",
	},
	loggedin: true,
	UseRole: {
		email: "",
		role: "",
	},
	roleValues: {},
	tagname: "",
	roles: [],
	leaderboardAdminAccess: false,
});

const getters = {
	getlicenseKey: (state) => state.licenseKey,
	checkLoginStatus: (state) => state.loggedin,
	getRoleData: (state) => state.user,
	getUseRoleData: (state) => state.UseRole,
	getRoleValues: (state) => state.roleValues,
	getTagName: (state) => state.tagname,
	getUserRefreshToken: (state) => state.refreshToken,
	getMenuStatus: (state) => state.showMenu,
	getleaderboardAdminAccess: (state) => state.leaderboardAdminAccess,
};
// actions
const actions = {
	// async getUserData(state) {
	//   getUserData()
	//     .then((res) => {
	//       let data = res.data.data.licenseKey;
	//       state.commit("saveLicenseKey", data);
	//     })
	//     .catch((err) => {
	//       throw err;
	//     });
	// },
	// Login Api
	//http://sso.simplifycv.com/auth/realms/SimplifyCV/protocol/openid-connect/token
	//https://auth.simplifycv.com/auth/realms/SimplifyCV/protocol/openid-connect/token
	Login({ commit }, userInfo) {
		return new Promise((resolve, reject) => {
			// axios({
			//   method: "post",
			//   url:
			//     "https://auth.simplifycv.com/auth/realms/SimplifyCV/protocol/openid-connect/token",
			//   data: userInfo.keycloak,
			//   headers: {
			//     "content-type": "application/x-www-form-urlencoded;charset=utf-8"
			//   }
			// })
			userLogin(userInfo.keycloak)
				.then((response) => {
					const data = response.data;
					if (data.access_token) {
						setToken(data.access_token);
						commit("SET_TOKEN", data.access_token);
						commit("SET_REFRESH_TOKEN", data.refresh_token);

						resolve(response);
					} else {
						reject(data);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},

	async getUserData({ commit }, setRoleValue) {
		try {
			const response = await getUserData();
			let data = await response.data.data.licenseKey;
			// return response
			let payload = {
				user: "USER",
				licensekey: data,
			};
			commit("saveLicenseKey", data);
			commit("saveLbAdminaccess", response.data.data.leaderboardAdminAccess);
			if (response.status == 200) {
				const res = await getAccessData(payload);
				let userDetails = await res.data.data.Data[0];
				const { permissions } = userDetails;

				if (setRoleValue == "setRole") {
					commit("SET_ROLES", permissions);
				}
				commit("getRoleValue", userDetails);
				return userDetails;
			} else {
				let userDetails = {};
				commit("getRoleValue", userDetails);
				throw new Error(`Failed! Value Not Stored`);
			}
		} catch (error) {
			throw new Error(`Getting Licencse Failed! status: ${error.status}`);
		}
	},

	// // LogOut Api
	// LogOut(state) {

	//   return new Promise((resolve, reject) => {
	//     axios({
	//       method: "post",
	//       url:
	//         "http://sso.simplifycv.com/auth/realms/SimplifyCV/protocol/openid-connect/logout",
	//         data: qs.stringify({
	//           client_id: "vue-test-app",
	//           refresh_token: store.state.userVUEX.refreshToken
	//         }),
	//       headers: {
	//         "content-type": "application/x-www-form-urlencoded;charset=utf-8",
	//         Authorization: `Bearer ${store.state.userVUEX.token}`
	//       }
	//     })
	//       .then(response => {
	//
	//         alert("User Logged Out");
	//         resolve();
	//       })
	//       .catch(error => {
	//         throw error();
	//         reject();
	//       });
	//   });
	// },

	// LogOut Api

	//"http://sso.simplifycv.com/auth/realms/SimplifyCV/protocol/openid-connect/logout
	//"https://auth.simplifycv.com/auth/realms/SimplifyCV/protocol/openid-connect/logout
	LogOut(state) {
		resetRouter();

		// axios({
		//   method: "post",
		//   url:
		//     "https://auth.simplifycv.com/auth/realms/SimplifyCV/protocol/openid-connect/logout",
		//   data: qs.stringify({
		//     client_id: "vue-test-app",
		//     refresh_token: store.state.userVUEX.refreshToken
		//   }),
		//   headers: {
		//     "content-type": "application/x-www-form-urlencoded;charset=utf-8",
		//     Authorization: `Bearer ${store.state.userVUEX.token}`
		//   }
		// })
		userLogOut(
			qs.stringify({
				client_id: "vue-test-app",
				refresh_token: getRefreshToken(),
			}),
			{
				"content-type": "application/x-www-form-urlencoded;charset=utf-8",
				Authorization: `Bearer ${getToken()}`,
			}
		)
			.then((response) => {
				state.commit("SET_ROLES", []);
				state.commit("SET_TOKEN", "");
				state.commit("SET_REFRESH_TOKEN", "");
				state.commit("saveLicenseKey", "");
				state.commit("getRoleValue", {});
				localStorage.clear();
				clearCookies();
				location.replace(
					`https://app.hire3x.com/login?from=assessment`
				);
				throw response;
			})
			.catch((error) => {
				state.commit("SET_ROLES", []);
				state.commit("SET_TOKEN", "");
				state.commit("SET_REFRESH_TOKEN", "");
				state.commit("saveLicenseKey", "");
				state.commit("getRoleValue", {});
				localStorage.clear();
				clearCookies();
				location.replace(
					`https://app.hire3x.com/login?from=assessment`
				);
				throw error();
			});
	},

	// async saveUserData(state, payload) {
	//   postUserData({ Authorization: payload.jwttoken }, { email: payload.email })
	//     .then(res =>{
	//       state.dispatch("getAccessPanelData", payload)})
	//   state.dispatch("getAccessPanelData", payload)
	//   state.commit("saveUserData", payload);
	// },

	// saveUser(state, payload) {
	//   state.dispatch("getAccessPanelData", payload);
	//   state.commit("saveUserData", payload);
	// },

	// Get Access Panel Value
	// async getAccessPanelData(state, payload) {
	//   // var data = await payload
	//   let data = {
	//     user: "USER",
	//     licensekey: store.state.userVUEX.licenseKey,
	//   };
	//   getAccessData({ userID: payload.jwttoken }, data)
	//     .then((res) => {
	//       if (res.status == 200) {
	//         let data = res.data.data.Data[0];

	//         // }
	//       }
	//       state.dispatch("getAccessRolesData", payload);
	//     })
	//     .catch((err) => {
	//
	//
	//       let data = {};
	//       state.commit("getRoleDet", data);
	//     });
	// },

	// Get Access Roles Value
	async getAccessRolesData(state, payload) {
		let data = store.state.userVUEX.UseRole.role;
		getAccessRoles({ userID: payload.jwttoken }, data)
			.then((res) => {
				if (res.status == 200) {
					data = res.data.data.data[0].components;
					state.commit("getRoleValue", data);
				}
			})
			.catch((err) => {
				throw err;
			});
	},
};
// mutations
const mutations = {
	// TOGGLE MENU SIDE BAR
	setMenuStatus(state, payload) {
		state.showMenu = payload;
	},

	// Storing LicenseKey
	saveLicenseKey(state, payload) {
		state.licenseKey = payload;
	},
	saveLbAdminaccess(state, payload) {
		state.leaderboardAdminAccess = payload;
	},
	// ---------------------------
	// ------- User Data ---------
	// ---------------------------
	saveUserData(state, payload) {
		state.user.userID = payload.jwttoken;
		state.user.email = payload.email;
	},
	checkLoginStatus(state, payload) {
		state.loggedin = payload;
	},
	// Storing Access Email
	getRoleDet(state, payload) {
		state.UseRole.email = payload.email;
		state.UseRole.role = payload.role;
	},
	// Storing Access Roles
	getRoleValue(state, payload) {
		state.roleValues = payload;
	},
	saveTagName(state, payload) {
		state.tagname = payload;
	},
	SET_TOKEN(state, token) {
		state.token = token;
	},
	SET_REFRESH_TOKEN(state, refreshToken) {
		state.refreshToken = refreshToken;
	},
	// Storing Roles Value
	SET_ROLES(state, roles) {
		state.roles = roles;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
